import {
  Button,
  DatePicker,
  Input,
  Popconfirm,
  Select,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { DeleteTwoTone, EditTwoTone, PictureOutlined } from "@ant-design/icons";
import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  deleteEmployeeById,
  getEmployeeList,
  selectEmployees,
} from "../../store/slices/employeeSlice";
import AddEmployeePopup from "./AddEmployeePopup";
import { config } from "../../config";
import { UpdatePhotoModal } from "./UpdatePhotoModal";

const { Search } = Input;
const { Text } = Typography;
const Employee = () => {
  const [loading, setLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPhotoModalVisible, setIsPhotoModalVisible] = useState(false);

  const [activeItem, setActiveitem] = useState(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOption, setFilterOption] = useState("all");
  const [pagination, setPagination] = useState({
    pageSizeOptions: ["10", "20", "50"],
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const employeeList = useSelector(selectEmployees);
  const dispatch = useDispatch();

  const getFilterValue = (value, filterOption) => {
    return value === filterOption
      ? true
      : value === "both"
      ? true
      : value === "all"
      ? undefined
      : false;
  };

  const fetchData = (
    pagination,
    searchTerm,
    startDate,
    endDate,
    isBodMember,
    showOnHomePage
  ) => {
    setLoading(true);
    dispatch(
      getEmployeeList(
        startDate?.format("YYYY-MM-DD 00:00:00"),
        endDate?.format("YYYY-MM-DD 23:59:00"),
        searchTerm ?? "",
        pagination.current,
        pagination.pageSize,
        isBodMember,
        showOnHomePage,
        (totalData) => {
          setPagination({ ...pagination, total: totalData });
          setLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    fetchData(pagination, searchTerm);
  }, []);

  const handleTableChange = (pagination) => {
    fetchData(
      pagination,
      searchTerm,
      startDate,
      endDate,
      getFilterValue(filterOption, "isBodMember"),
      getFilterValue(filterOption, "showOnHomePage")
    );
  };

  const handleDelete = (item) => {
    setConfirmLoading(true);
    dispatch(
      deleteEmployeeById(item.id, () => {
        setConfirmLoading(false);
      })
    );
  };

  const handleFilterChange = (value) => {
    setFilterOption(value);

    fetchData(
      pagination,
      searchTerm,
      startDate,
      endDate,
      getFilterValue(value, "isBodMember"),
      getFilterValue(value, "showOnHomePage")
    );
  };

  const columns = [
    {
      title: "Photo",
      dataIndex: "filePath",
      render: (value, record) => {
        return (
          <img
            src={`${config.filesBaseUrl}/${value}`}
            alt={record.name}
            width={80}
          />
        );
      },
      width: "100px",
    },
    {
      title: "Name",
      dataIndex: "name",
    },

    {
      title: "Position",
      dataIndex: "position",
      width: "150px",
    },
    {
      title: "Info",
      dataIndex: "info",
      width: "150px",
    },
    {
      title: "Rank",
      dataIndex: "rank",
      width: "80px",
    },
    {
      title: "Is Bod Member",
      dataIndex: "isBodMember",
      render: (_) => {
        return (
          <>{_ ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>}</>
        );
      },
      width: "100px",
    },
    {
      title: "Show on Home Page",
      dataIndex: "showOnHomePage",
      render: (_) => {
        return (
          <>{_ ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>}</>
        );
      },
      width: "100px",
    },

    {
      title: "Actions",
      dataIndex: "isPublished",
      width: "100px",
      render: (_, record) => {
        return (
          <Space style={{ justifyContent: "center", width: "100%" }}>
            <EditTwoTone
              title="Edit"
              twoToneColor="#1890ff"
              style={{
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={() => {
                setActiveitem(record);
                setIsModalVisible(true);
              }}
            />
            <PictureOutlined
              title="Update photo"
              style={{
                color: "#005500",
                fontSize: "20px",
                cursor: "pointer",
                marginLeft: "4px",
              }}
              onClick={() => {
                setActiveitem(record);
                setIsPhotoModalVisible(true);
              }}
            />

            <Popconfirm
              confirmLoading={confirmLoading}
              title="Are you sure want to delete this employee?"
              onConfirm={() => handleDelete(record)}
              placement="topRight"
            >
              <DeleteTwoTone
                title="Delete"
                twoToneColor="#ff0000"
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
              />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold" }}>Employees</h2>
      {isModalVisible && (
        <AddEmployeePopup closePopup={setIsModalVisible} item={activeItem} />
      )}
      {isPhotoModalVisible && (
        <UpdatePhotoModal
          closePopup={setIsPhotoModalVisible}
          item={activeItem}
        />
      )}
      <Space
        style={{
          width: "100%",
          marginBottom: "15px",
          justifyContent: "flex-end",
        }}
        size={10}
        direction="horizontal"
        align="end"
      >
        <Space direction="vertical">
          <Text>Start Date:</Text>
          <DatePicker
            format="MM/DD/YYYY"
            value={startDate}
            placeholder="Select start date"
            onChange={(value) => {
              setStartDate(value);
              fetchData(
                pagination,
                searchTerm,
                value,
                endDate,
                getFilterValue(filterOption, "isBodMember"),
                getFilterValue(filterOption, "showOnHomePage")
              );
            }}
            disabledDate={(current) => {
              return moment().add(0, "days") < current;
            }}
          />
        </Space>
        <Space direction="vertical">
          <Text>End Date:</Text>
          <DatePicker
            format="MM/DD/YYYY"
            defaultValue={startDate}
            placeholder="Select end date"
            onChange={(value) => {
              setEndDate(value);
              fetchData(
                pagination,
                searchTerm,
                startDate,
                value,
                getFilterValue(filterOption, "isBodMember"),
                getFilterValue(filterOption, "showOnHomePage")
              );
            }}
            disabledDate={(current) => {
              return moment().add(0, "days") < current || startDate > current;
            }}
          />
        </Space>
        <Space direction="vertical">
          <Text>Filter (employee type):</Text>
          <Select
            value={filterOption}
            onChange={handleFilterChange}
            style={{ width: 200 }}
          >
            <Select.Option value="all">All</Select.Option>
            <Select.Option value="isBodMember">Is Bod Member</Select.Option>
            <Select.Option value="showOnHomePage">
              Show on Home Page
            </Select.Option>
            <Select.Option value="both">Both</Select.Option>
          </Select>
        </Space>
        <Space direction="vertical">
          <Text>Search(name):</Text>
          <Search
            allowClear
            placeholder="Search"
            onSearch={(value) => {
              setSearchTerm(value);
              fetchData(
                pagination,
                value,
                startDate,
                endDate,
                getFilterValue(filterOption, "isBodMember"),
                getFilterValue(filterOption, "showOnHomePage")
              );
            }}
            enterButton
            style={{ width: "350px" }}
          />
        </Space>
        <Button
          type="primary"
          onClick={() => {
            setIsModalVisible(true);
            setActiveitem(null);
          }}
        >
          Add Employee
        </Button>
      </Space>
      <Table
        dataSource={employeeList}
        columns={columns}
        loading={loading}
        bordered
        rowKey="id"
        pagination={pagination}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Employee;
